import { Navigate } from "react-router-dom";
import Navbar from "./Navbar";

const ProtectedRoute = ({ children }) => {
  // Check if the localStorage value exists
  console.log(localStorage.getItem("logged_in"));
  const isAuthenticated = localStorage.getItem("logged_in") === 'true'; // Replace 'authToken' with your key

  return isAuthenticated ? (
    <>
      {" "}
      <Navbar /> {children}
    </>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
